import { api } from "constants/RotasAPI";
import { useMutation } from "react-query";
import { queryClient } from "shared/util/queryClient";
import axios from "axios";

export const usePutStatusWizardGroupPay = () => {
  return useMutation({
    mutationFn: async (novoStatus: string) => {
      const response = await axios.put(
        `${api.wizard.atualizarStatusWizard}/CONFIGURACAO_GROUP_PAY/status`,
        novoStatus, 
        {
          headers: {
            'Content-Type': 'text/plain', 
          },
        }
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["status-wizard", "CONFIGURACAO_GROUP_PAY"]);
    },
  });
};